/**
 * Billedsortering baseret på officielle upload-datoer fra CMS / Asset Library.
 * Sikrer at nyeste upload-dato ALTID vises først på tværs af hele sitet.
 *
 * Dato-hierarki (nyest til ældst):
 * 1. 06. okt. 2026 (Nyeste mobilfotos)
 * 2. 23. sep. 2026
 * 3. 07. sep. 2026
 * 4. 21. aug. 2026 (Min film 3)
 * 5. 20. aug. 2026 (imgi_* og nyere optimerede fotos)
 * 6. 17. aug. 2026
 * 7. 06. aug. 2026 (Facebook/web optimeringer)
 * 8. 29. jul. 2026 (Oprindeligt arkiv / scrape)
 */

// Billeder uploadet 6. oktober 2026
const UPLOADED_2026_10_06 = [
  'img-0400',
  'img-0374',
  'img-0283',
  'img-0295',
  'img-0286',
  'img-0296',
  'img-0297',
  'img-0274',
  'img-0273',
  'img-0220',
  'img-0214',
  'img-0216',
  'img-0208',
  'img-0159',
  'img-0124',
  'img-0122',
  'img-0063',
  'img-0012',
  'img-9541',
  'img-9538',
  'img-9536',
  'img-9534',
  'img-9535',
  'img-9530',
  'img-9515',
  'img-9513',
  'img-9517_ec9693c7',
  'img-9507',
  'img-9484'
];

// Billeder uploadet 23. september 2026
const UPLOADED_2026_09_23 = [
  'img-9841',
  'att-i7un1j13o5ej7lplbu1ty0z9znu9hqszkp07qxbh-ag_ff091133',
  'img-9744',
  'img-9735',
  'img-0029',
  'img-0025_bfa50bd9',
  'img-0022',
  'img-0018_346b0730',
  'img-0018'
];

// Billeder uploadet 7. september 2026
const UPLOADED_2026_09_07 = [
  'img-0158',
  'img-0152',
  'img-0151',
  'img-0082',
  'img-0069',
  'img-0057',
  'img-0025',
  'img-9944',
  'img-9939',
  'img-9892',
  'img-9887',
  'img-9940',
  'img-9938',
  'img-9886',
  'img-9895',
  'img-9882',
  'img-9878',
  'img-9875',
  'att-ggxuzbsir6epn-bom8xxu9htylpoava6kx31vhzivou',
  'img-9827',
  'img-9781',
  'att-i7un1j13o5ej7lplbu1ty0z9znu9hqszkp07qxbh-ag',
  'img-9614',
  'img-9612',
  'img-9611',
  'img-9593',
  'img-9564',
  'img-9556',
  'img-9555',
  'img-9546',
  'img-9517',
  'img-9444',
  'img-9362',
  'img-9357',
  'img-8504',
  'img-8490',
  'img-8450',
  'img-8410',
  'img-8407',
  'img-8283',
  'img-8240',
  'img-7612',
  'img-7515',
  'img-7546',
  'img-7914'
];

// Billeder uploadet 20. august 2026
const UPLOADED_2026_08_20_FILES = [
  '65861489a987e_0',
  '66c78e771bf1c',
  '6800a373d0225',
  '6800a373afff0',
  '685cdb6de4723',
  '685cdb6dd6769',
  '685cdbef4c510',
  '685cdbef39d9c',
  'groen_anlaegsgartner',
  'groen-anlaegsgartner',
  'beforeafterpreview',
  '1_20_281_29_0',
  '1-20-281-29-0',
  '66c4f44f466f8',
  '66c4f44f4a78b',
  '66c4f44f4eb97',
  '66c4f44f51a21',
  '66c4f44f54cb2',
  '66c4f44f57c20'
];

// Billeder uploadet 6. august 2026
const UPLOADED_2026_08_06 = [
  '265959446182484',
  '203665715745191',
  '230080803103682'
];

/**
 * Normaliserer en fil-URL til et simpelt søgbart ID
 */
function normalizeUrl(url) {
  if (!url) return '';
  let str = String(url).toLowerCase();
  // Fjern querystrings og host
  str = str.split('?')[0];
  const parts = str.split('/');
  let filename = parts[parts.length - 1] || '';
  // Fjern filtype
  filename = filename.replace(/\.(jpeg|jpg|png|webp|mp4|gif|svg)$/i, '');
  // Erstat underscores med bindestreg (medmindre det er et velkendt hash-suffix)
  return filename;
}

/**
 * Beregner en numerisk score hvor en højere værdi betyder nyere upload-dato.
 * Derved sorterer sort((a, b) => getScore(b) - getScore(a)) nyeste billeder først.
 */
export function getImageRecencyScore(rawUrl) {
  const norm = normalizeUrl(rawUrl);
  if (!norm) return 0;

  // 1. Tjek 6. oktober 2026 (Tier 8)
  for (let i = 0; i < UPLOADED_2026_10_06.length; i++) {
    const key = UPLOADED_2026_10_06[i];
    if (norm === key || norm.startsWith(`${key}_`) || norm.startsWith(`${key}-`) || (key.includes('_') && norm.includes(key.split('_')[0]) && norm.includes(key.split('_')[1]))) {
      // Prioritér efter præcis position i listen så rækkefølgen inden for 6. okt respekteres
      return 800000 - i;
    }
  }

  // Fallback for ethvert 6. okt foto hvis det matcher nummer
  for (let i = 0; i < UPLOADED_2026_10_06.length; i++) {
    const baseNum = UPLOADED_2026_10_06[i].replace('img-', '').split('_')[0];
    if (norm.includes(`img-${baseNum}`) || norm.includes(`img_${baseNum}`)) {
      return 800000 - i;
    }
  }

  // 2. Tjek 23. september 2026 (Tier 7)
  for (let i = 0; i < UPLOADED_2026_09_23.length; i++) {
    const key = UPLOADED_2026_09_23[i];
    if (norm === key || norm.startsWith(`${key}_`) || norm.startsWith(`${key}-`)) {
      return 700000 - i;
    }
    // Håndter att-i7un med hash
    if (key.startsWith('att-i7un') && norm.includes('ff091133')) {
      return 700000 - i;
    }
    // Håndter 0029, 0025 osv. med hash
    const baseNum = key.replace('img-', '').split('_')[0];
    if (norm.startsWith(`img-${baseNum}_`) || norm.startsWith(`img_${baseNum}_`)) {
      return 700000 - i;
    }
  }

  // 3. Tjek 7. september 2026 (Tier 6)
  for (let i = 0; i < UPLOADED_2026_09_07.length; i++) {
    const key = UPLOADED_2026_09_07[i];
    if (norm === key || norm.startsWith(`${key}_`) || norm.startsWith(`${key}-`)) {
      return 600000 - i;
    }
    const baseNum = key.replace('img-', '').split('_')[0];
    if (norm.includes(`img-${baseNum}`) || norm.includes(`img_${baseNum}`)) {
      return 600000 - i;
    }
    if (key.startsWith('att-ggxuz') && norm.includes('att-ggxuz')) {
      return 600000 - i;
    }
    if (key.startsWith('att-i7un') && norm.includes('att-i7un')) {
      return 600000 - i;
    }
  }

  // 4. Tjek 21. august 2026 (Tier 5 - Min film)
  if (norm.includes('min-film') || norm.includes('min_film')) {
    return 500000;
  }

  // 5. Tjek 20. august 2026 (Tier 4 - imgi_*, image_* og optimerede fotos)
  if (norm.startsWith('imgi_') || norm.startsWith('imgi-')) {
    // imgi fotos uploadet 20. aug
    return 450000;
  }
  if (norm.startsWith('image_') || norm === 'image' || norm.startsWith('image-')) {
    // image.png uploads fra 20. aug
    return 420000;
  }
  for (let i = 0; i < UPLOADED_2026_08_20_FILES.length; i++) {
    const key = UPLOADED_2026_08_20_FILES[i];
    if (norm.includes(key)) {
      return 400000 - i;
    }
  }

  // 6. Tjek 17. august 2026 (Tier 3)

  // 7. Tjek 6. august 2026 (Tier 2 - Facebook/webp fotos)
  for (let i = 0; i < UPLOADED_2026_08_06.length; i++) {
    const key = UPLOADED_2026_08_06[i];
    if (norm.includes(key)) {
      return 200000 - i;
    }
  }

  // 8. Tjek 29. juli 2026 (Tier 1 - Oprindeligt arkiv / scrape)
  if (norm.includes('havearbejde') || norm.includes('belaegning-')) {
    return 100000;
  }
  if (norm.startsWith('65') || norm.startsWith('66') || norm.startsWith('68')) {
    return 120000;
  }

  // Nye filer uploadet fremadrettet (efter 6. okt. 2026) som ikke findes i den historiske tabel
  // tildeles højeste score (Tier 9: 900.000+), så de automatisk lægger sig helt i toppen foran 6. okt.
  return 900000;
}

/**
 * Sortér et array af billeder efter nyeste upload-dato først.
 * Accepterer enten et array af strenge (URLs) eller objekter med en `.url` property.
 */
export function sortImagesByUploadDate(images) {
  if (!Array.isArray(images) || images.length === 0) return [];
  return [...images].sort((a, b) => {
    const urlA = typeof a === 'string' ? a : (a?.url || '');
    const urlB = typeof b === 'string' ? b : (b?.url || '');
    return getImageRecencyScore(urlB) - getImageRecencyScore(urlA);
  });
}
